import styles from '~/components/Auction/Auction.scss';
import { items } from '@wg/wows-entities/const';
import { CommanderName } from '~/components/Commanders/Commanders';
import classNames from 'classnames';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';

interface IAuctionLotHeader extends ILot {
    crewClassName?: string;
    isPage?: boolean;
}

const AuctionLotHeader = (props: IAuctionLotHeader) => {
    const commonLotType = props.entitlements?.[0]?.type;
    const classesTitle = classNames({
        [styles.title]: !props.isPage,
        [styles.pageTitle]: props.isPage,
    });

    if (props.denyTitleModification) {
        return <div className={classesTitle}>{props.title}</div>;
    }

    switch (commonLotType) {
        case items.VEHICLES:
            const ship = props.entitlements[0];

            return <WoWSEntity id={Number(ship.id)} type={items.VEHICLES} />;

        case items.CREWS:
            const crew = props.entitlements[0];

            return <CommanderName name={props.title} id={Number(crew.id)} className={props.crewClassName} />;

        default:
            return <div className={classesTitle}>{props.title}</div>;
    }
};

export default AuctionLotHeader;
